import Enumerator from '../global/Enumerator';

export const contactEmploymentClasses = [
  'none',
  'class_one',
  'class_two',
  'class_three',
  'class_four',
  'class_five'
];

export class ContactEmploymentClass extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'class_one';
        break;
      case '2':
        correctOption = 'class_two';
        break;
      case '3':
        correctOption = 'class_three';
        break;
      case '4':
        correctOption = 'class_four';
        break;
      case '5':
        correctOption = 'class_five';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ContactEmploymentClass.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  class_one: {
    get title() {
      return 'Class 1';
    }
  },
  class_two: {
    get title() {
      return 'Class 2';
    }
  },
  class_three: {
    get title() {
      return 'Class 3';
    }
  },
  class_four: {
    get title() {
      return 'Class 4';
    }
  },
  class_five: {
    get title() {
      return 'Class 5';
    }
  }
});

export default {
  contactEmploymentClasses,
  ContactEmploymentClass
};
